import React, { useState } from 'react';

import AccountUserDetailLikeBrandLogModal from './AccountUserDetailLikeBrandLogModal';
import LabelInfo from '../../../../../components/LabelInfo';
import Anchor from '../../../../../components/link/Anchor';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import {
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE,
  LIKE_BRAND_LIST_TABLE_EMPTY_TEXT,
} from '../../../../../constants/service/app/accountUserConstants';
import {
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_FILER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_SORT_OPTION_MODEL,
} from './models';
import { useAccountUserDetailLikeBrandList, useAccountUserLikeBrandDetail } from './hooks';
import columns from './columns';
import './AccountUserDetailLikeBrandInfo.scss';

const AccountUserDetailLikeBrandInfo = (props) => {
  const { userId, isActive } = props;

  const [actionLogType, setActionLogType] = useState();
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => {
    setModalOpen(false);
    setActionLogType(null);
  };
  const openModal = ({ actionLogType }) => {
    setModalOpen(true);
    setActionLogType(actionLogType);
  };

  const { totalAddCount, totalRemoveCount, totalClickCount } = useAccountUserLikeBrandDetail({ userId, isActive });
  const { likeBrandHistory, filterOption, sortOption, getList } = useAccountUserDetailLikeBrandList({
    userId,
    isActive,
  });
  const { list, totalCnt } = likeBrandHistory;

  return (
    <div className="account-user-detail-content account-user-detail-like-brand-content">
      <div className="account-user-detail-section">
        <div className="title">좋아요 한 브랜드 리스트</div>

        <div className="account-user-detail-section-content">
          <div className="form-wrap">
            <LabelInfo
              label="총 브랜드 클릭수"
              info={
                <Anchor
                  text={totalClickCount}
                  isUnderLine
                  color="primary"
                  onClick={() =>
                    openModal({
                      actionLogType: ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.CLICK,
                    })
                  }
                />
              }
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="총 브랜드 좋아요 추가수"
              info={
                <Anchor
                  text={totalAddCount}
                  isUnderLine
                  color="primary"
                  onClick={() =>
                    openModal({
                      actionLogType: ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.LIKE,
                    })
                  }
                />
              }
            />
          </div>

          <div className="form-wrap">
            <LabelInfo
              label="총 브랜드 좋아요 삭제수"
              info={
                <Anchor
                  text={totalRemoveCount}
                  isUnderLine
                  color="primary"
                  onClick={() =>
                    openModal({
                      actionLogType: ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.UNLIKE,
                    })
                  }
                />
              }
            />
          </div>
        </div>

        <div className="account-user-detail-section-content like-brand-list">
          <TableWithSummary
            className="account-user-detail-section-list"
            data={list}
            totalCnt={totalCnt}
            isStriped={true}
            emptyText={LIKE_BRAND_LIST_TABLE_EMPTY_TEXT}
            initialOption={{
              filterOption: ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_FILER_OPTION_MODEL,
              sortOption: ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_SORT_OPTION_MODEL,
            }}
            filterOption={filterOption}
            sortOption={sortOption}
            getList={getList}
            columns={(utils) => columns(utils)}
          />
        </div>
      </div>
      {isModalOpen && (
        <AccountUserDetailLikeBrandLogModal
          userId={userId}
          actionLogType={actionLogType}
          closeModal={closeModal}
          setActionLogType={setActionLogType}
        />
      )}
    </div>
  );
};

export default AccountUserDetailLikeBrandInfo;
